export const config = {
    java_api_url: "https://client.evote50.dltc.spbu.ru:443/api",
    client_url: "https://client.evote50.dltc.spbu.ru",
    enable_esia: false
};